import React from "react";

export default function ThankYou(props) {

    return (
        <div>
            <h3>{props.translations.allDone}</h3>
            <p>{`${props.translations.youSearch} ${props.name} ${props.translations.beenSaved}`}</p>
            <button className="btn btn-primary" onClick={props.onRequestClose} >{props.translations.finished}</button>
        </div>
    );

}